




















import { Component, Mixins } from "vue-property-decorator";
import { Point, Alignments } from "../../../../../../base/domain/drawing";
import { ModelEditableMixin } from "../../../../../../base/components/system/mixins";
import { AlignmentDropDownSelector, PointEditor, SizeEditor } from "../../../../../../base/components/drawing";
import { RectangleCoordinateEditableMixin } from "../objects/mixins";

@Component({
  components: {
    AlignmentDropDownSelector,
    PointEditor,
    SizeEditor,
  },
})
export default class RectangleCoordinateEditor extends Mixins(ModelEditableMixin, RectangleCoordinateEditableMixin) {
  data() {
    return {
      locationAlignment: Alignments.TopLeft,
    };
  }
  locationAlignment: Alignments;

  get locationAlignments(): Alignments[] {
    return [
      Alignments.TopLeft,
      Alignments.MiddleCenter,
      Alignments.BottomRight,
    ];
  }

  get locationToEdit(): Point {
    return this.locationAccessor.read();
  }

  set locationToEdit(value: Point) {
    this.locationAccessor.write(value);
  }

  get locationAccessor(): { read: () => Point, write: (v: Point) => void } {
    // あまりswitch～caseは使いたくないが...enum全て定義するわけじゃないのでここは諦める.
    switch (this.locationAlignment) {
      case Alignments.TopLeft:
        return {
          read: () => this.topLeft,
          write: (v: Point) => this.topLeft = v,
        };
      case Alignments.MiddleCenter:
        return {
          read: () => this.center,
          write: (v: Point) => this.center = v,
        };
      case Alignments.BottomRight:
        return {
          read: () => this.bottomRight,
          write: (v: Point) => this.bottomRight = v,
        };
    }
  }
}
